import { render, staticRenderFns } from "./ServicePermissions.vue?vue&type=template&id=75df7e0f&"
import script from "./ServicePermissions.vue?vue&type=script&lang=js&"
export * from "./ServicePermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports